var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-cancel",
    "data-name": "Icon material-cancel",
    d: "M13,3A10,10,0,1,0,23,13,9.991,9.991,0,0,0,13,3Zm5,13.59L16.59,18,13,14.41,9.41,18,8,16.59,11.59,13,8,9.41,9.41,8,13,11.59,16.59,8,18,9.41,14.41,13Z",
    transform: "translate(-3 -3)",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelWhite);
export default __webpack_public_path__ + "static/media/cancel_white.79b366490b27413b185ff367c0b1137f.svg";
export { ForwardRef as ReactComponent };